import { render } from "./Jamakkol.vue?vue&type=template&id=d75a3f80&scoped=true"
import script from "./Jamakkol.vue?vue&type=script&lang=js"
export * from "./Jamakkol.vue?vue&type=script&lang=js"

import "./Jamakkol.vue?vue&type=style&index=0&id=d75a3f80&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d75a3f80"]])

export default __exports__